/**
 * ClientCell
 * Exibe cliente com logo (ou ícone padrão), nome e ID do cliente.
 * Reutilizado em listas de clientes em várias páginas.
 */

import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { Business } from '@mui/icons-material';
import { CopyableId } from './CopyableId';

export interface ClientCellProps {
  /** Nome do cliente (empresa) */
  name?: string | null | undefined;
  /** ID único do tenant/cliente */
  tenantId: string;
  /** URL da logo do cliente (opcional; se não houver, exibe ícone padrão) */
  logoUrl?: string | null | undefined;
  /** Tamanho do avatar */
  size?: 'small' | 'medium' | undefined;
}

const sizeMap = { small: 32, medium: 40 };

export const ClientCell: React.FC<ClientCellProps> = ({
  name,
  tenantId,
  logoUrl,
  size = 'medium'
}) => {
  const avatarSize = sizeMap[size];
  const displayName = name?.trim() || tenantId;
  const showSecondary = name?.trim() && tenantId;

  const hasLogo = typeof logoUrl === 'string' && logoUrl.trim() !== '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Avatar
        {...(hasLogo ? { src: logoUrl } : {})}
        sx={{
          width: avatarSize,
          height: avatarSize,
          bgcolor: hasLogo ? undefined : 'primary.main',
          color: hasLogo ? undefined : 'primary.contrastText'
        }}
      >
        {!hasLogo &&
          (displayName && displayName !== tenantId ? (
            displayName.charAt(0).toUpperCase()
          ) : (
            <Business sx={{ fontSize: size === 'small' ? 18 : 22 }} />
          ))}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" fontWeight={500} noWrap>
          {displayName}
        </Typography>
        {showSecondary && (
          <Typography variant="caption" color="text.secondary" noWrap display="block">
            Tenant: <CopyableId value={tenantId} label="tenantId" />
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ClientCell;
